import { booleanAttribute } from "#ce/utils/props";

export const props = Object.freeze({
  /**
   * Heading of the waitlist modal.
   *
   * @type {String}
   * @default "Waitlist"
   */
  modalTitle: {
    type: String,
    default: "Waitlist",
  },
  /**
   * Label of the activator that opens the modal.
   *
   * @type {String}
   * @default "Join Waitlist"
   */
  activatorText: {
    type: String,
    default: "Join Waitlist",
  },
  /**
   * Colour of the activator button. Passed through to `sp-button`, so it takes the same values.
   *
   * @type {String}
   * @default "default"
   */
  activatorColor: {
    type: String,
    default: "default",
  },
  /**
   * Variant of the activator button. Passed through to `sp-button`, so it takes the same values.
   *
   * @type {String}
   * @default "flat"
   */
  activatorVariant: {
    type: String,
    default: "flat",
  },
  /**
   * Render the activator as an inline link instead of a button — for placing the waitlist inside
   * a sentence rather than as a standalone call to action.
   *
   * @type {Boolean|String}
   * @default false
   */
  activatorAsLink: booleanAttribute(),
  /**
   * Label for the sticky mobile call-to-action activator. Omit to render no mobile CTA.
   *
   * @type {String}
   * @default undefined
   */
  mobileCtaActivatorText: {
    type: String,
    default: undefined,
  },
  /**
   * Introductory text shown above the form inside the modal.
   *
   * @type {String}
   * @default undefined
   */
  preamble: {
    type: String,
    default: undefined,
  },
  /**
   * Informational message shown above the form inside the modal, below the preamble.
   *
   * @type {String}
   * @default undefined
   */
  info: {
    type: String,
    default: undefined,
  },
});
